











import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "date-range-chart": () =>
      import("@/components/app/global/stats/charts/_dateRangeChart.vue")
  }
})
export default class TransactionsChart extends Vue {}
